import React from 'react';
import { GridContext } from './state';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const Pagination = () => {
    const { state, dispatch, page, maxRows, events } = React.useContext(GridContext);

    const dataCount = maxRows || state.data.length;
    const totalPages = Math.ceil(dataCount / state.pageSize);

    const handleSetPage = page => {
        if (events.onPageChange) events.onPageChange(page);
        else dispatch.setPage(page);
    };

    const handleSetPageSize = (pageSize) => {
        if(!maxRows) {
            dispatch.setPage(0);
            dispatch.setPageSize(pageSize);
        }
        else if(Object.prototype.hasOwnProperty.call(events, "onPageSizeChange")) events.onPageSizeChange(pageSize);
        else dispatch.setPageSize(pageSize); 
    };

    return (
        <div className='flex items-center justify-between'>
            <PageIndicator currentPage={page || state.pageIndex} totalPages={totalPages} setPage={handleSetPage} />
            {<PageSizeControl setPageSize={handleSetPageSize} pageSize={state.pageSize} dataCount={dataCount} />}
            <CountIndicator dataCount={dataCount} pageSize={state.pageSize} pageIndex={page || state.pageIndex} />
        </div>
    );
};

export default Pagination;

function PageIndicator({ currentPage, totalPages, setPage }) {
    const hasNextPage = currentPage + 1 < totalPages;
    const hasPrevPage = currentPage > 0;

    return (
        <div className='grid grid-cols-4 h-10'>
            <span className='h-full w-full flex items-center justify-center'>
                {hasPrevPage && (<button className='focus:outline-none' onClick={() => setPage(currentPage - 1)}><FiArrowLeft /></button>)}
            </span>
            <span className='flex items-center justify-center col-start-2 col-span-2'>
                <p className='text-sm'>Page {currentPage + 1} of {totalPages}</p>
            </span>
            <span className='flex items-center justify-center'>
                {hasNextPage && (<button className='focus:outline-none' onClick={() => setPage(currentPage + 1)}><FiArrowRight /></button>)}
            </span>
        </div>
    );
}

function PageSizeControl({ pageSize, setPageSize, dataCount }) {
    return (
        <div className='flex h-10 items-center justify-around text-sm'>
            <p className='pr-2'>View</p>
            <button className='text-blue-50 disabled:opacity-50 focus:outline-none pr-2' disabled={pageSize == 10} onClick={() => setPageSize(10)}>10</button>
            <button className='text-blue-50 disabled:opacity-50 focus:outline-none pr-2' disabled={pageSize == 20} onClick={() => setPageSize(20)}>20</button>
            <button className='text-blue-50 disabled:opacity-50 focus:outline-none pr-2' disabled={pageSize == 40} onClick={() => setPageSize(40)}>40</button>
            <button className='text-blue-50 disabled:opacity-50 focus:outline-none pr-2' disabled={pageSize == dataCount} onClick={() => setPageSize(dataCount)}>All</button>
        </div>
    );
}

function CountIndicator({ dataCount, pageIndex, pageSize }) {
    const startIndex = 1 + (pageSize * pageIndex);
    let lastIndex = startIndex + pageSize - 1;

    if (lastIndex > dataCount) {
        lastIndex = dataCount;
    }

    return (
        <div>
            <p>{startIndex} - {lastIndex} of {dataCount} items</p>
        </div>
    );
}